import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { useDispatch, useSelector } from 'react-redux';

import axios from 'axios';

import BarsLoadingIndicator from '../common/barsLoadingIndicator/BarsLoadingIndicator';
import { updateChannel } from '../../features/MiniBookingWidget/MiniBookingWidgetSlice';
import { updateMultiPropertyChannel } from 'features/multiproperty/MultipropertySlice';

import './Channel.css';

const Channel = ({
    url,
    handleClick,
    logo,
    logoSize = 20,
    name,
    currencySymbol,
    price,
    extraClasses = [],
    styles,
    disablePointerEvents = true,
    channelId,
    isMultiproperty,
}) => {
    // TODO: REFACTOR PASS A PROP FOR THE HOVER ANIMATION
    const [loading, setLoading] = useState(false);
    // Chanel price should be shown after the main prices
    const ratesReady = useSelector(
        (state) => state.miniBookingWidget.ratesReady
    );
    // const isPriceAvailable =
    //     typeof price === 'string' && !price.startsWith('getprice');

    // const isValidPrice =
    //     // eslint-disable-next-line no-useless-escape
    //     typeof price === 'string' && /^\d+[\d\.?,?\d]+\d+$/.test(price);
    const [resolvedPrice, setResolvedPrice] = useState(price);
    const isValidPrice =
        typeof resolvedPrice === 'string' &&
        /^\d+([.,]?\d+)*$/.test(resolvedPrice);
    const isPriceAvailable = isValidPrice && !loading;
    const dispatch = useDispatch();

    logoSize = typeof logoSize === 'string' ? logoSize : logoSize + 'px';

    const allChannels = useSelector(
        (state) => state.miniBookingWidget?.channels || []
    );
    const thisChannel = allChannels.find((c) => c.channelID === channelId);

    useEffect(() => {
        const abortCtrl = new AbortController();
        const opts = { signal: abortCtrl.signal };

        (async () => {
            if (price.startsWith('getprice') && ratesReady) {
                const url = price.split('getprice:')[1];
                setLoading(true);
                try {
                    const response = await axios.get(url, opts);
                    const newPrice = response?.data ?? '';

                    setResolvedPrice(newPrice);

                    const updatePayload = {
                        channelName: name,
                        price: newPrice,
                        channelId,
                    };
                    dispatch(
                        isMultiproperty
                            ? updateMultiPropertyChannel(updatePayload)
                            : updateChannel(updatePayload)
                    );
                } catch (error) {
                    if (error.message !== 'canceled') {
                        setResolvedPrice('');
                        const updatePayload = {
                            channelName: name,
                            price: '',
                            channelId,
                        };
                        dispatch(
                            isMultiproperty
                                ? updateMultiPropertyChannel(updatePayload)
                                : updateChannel(updatePayload)
                        );
                    }
                }
                setLoading(false);
            } else if (
                price === 'getFromState' &&
                ratesReady &&
                thisChannel?.price
            ) {
                setResolvedPrice(thisChannel.price);

                const updatePayload = {
                    channelName: name,
                    price: thisChannel.price,
                    channelId,
                };
                dispatch(
                    isMultiproperty
                        ? updateMultiPropertyChannel(updatePayload)
                        : updateChannel(updatePayload)
                );
            }
            setLoading(false);
        })();

        return () => abortCtrl.abort();
    }, [price, ratesReady, thisChannel?.price]);

    return (
        resolvedPrice && (
            <div
                className={`ab-channel ${extraClasses.join(' ')}`}
                style={{ ...styles }}
            >
                {url ? (
                    <a
                        href={url}
                        target="_blank"
                        rel="noopener noreferrer"
                        onClick={handleClick}
                    >
                        <div className="ab-mini-widget-row">
                            <div className="ab-left">
                                {logo && (
                                    <>
                                        <img
                                            src={logo}
                                            alt={name}
                                            style={{
                                                width: logoSize,
                                            }}
                                        />{' '}
                                    </>
                                )}
                                <span className="ab-channel-name">{name}</span>
                            </div>
                            <div className="ab-right">
                                {loading || !isPriceAvailable ? (
                                    <BarsLoadingIndicator
                                        classes="ab-bars-loading-indicator--light-gray"
                                        size={25}
                                    />
                                ) : (
                                    <div className="ab-channel-price">
                                        {isValidPrice && (
                                            <>
                                                <span className="ab-currency-symbol">
                                                    {currencySymbol}
                                                </span>{' '}
                                            </>
                                        )}

                                        <span>{resolvedPrice}</span>
                                    </div>
                                )}
                            </div>
                        </div>
                    </a>
                ) : (
                    <div
                        className={`ab-mini-widget-row ${
                            disablePointerEvents ? 'ab-no-pointer-events' : ''
                        }`}
                        onClick={handleClick}
                    >
                        <div className="ab-left">
                            {logo && (
                                <>
                                    <img
                                        src={logo}
                                        alt={name}
                                        style={{
                                            width: logoSize,
                                        }}
                                    />{' '}
                                </>
                            )}
                            <span className="ab-channel-name">{name}</span>
                        </div>
                        <div className="ab-right">
                            {loading || !isPriceAvailable ? (
                                <BarsLoadingIndicator classes="ab-bars-loading-indicator--light-gray" />
                            ) : (
                                <div className="ab-channel-price">
                                    {isValidPrice && (
                                        <>
                                            <span className="ab-currency-symbol">
                                                {currencySymbol}
                                            </span>{' '}
                                        </>
                                    )}

                                    <span>{resolvedPrice}</span>
                                </div>
                            )}
                        </div>
                    </div>
                )}
            </div>
        )
    );
};

Channel.propTypes = {
    disablePointerEvents: PropTypes.bool,
    url: PropTypes.string,
    handleClick: PropTypes.func,
    name: PropTypes.string.isRequired,
    logoSize: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    logo: PropTypes.string,
    currencySymbol: PropTypes.string.isRequired,
    price: PropTypes.string.isRequired,
    extraClasses: PropTypes.array,
    styles: PropTypes.object,
    channelId: PropTypes.number,
    isMultiproperty: PropTypes.bool,
};

export default Channel;
